var _circle, _circle2, _circle3, _circle4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKongiDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 -6 170 170",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 22,
    fill: "#EDAA4F",
    stroke: "#4A3426",
    strokeWidth: 3.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 11,
    fill: "#F5B8A5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 46,
    r: 22,
    fill: "#EDAA4F",
    stroke: "#4A3426",
    strokeWidth: 3.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 46,
    r: 11,
    fill: "#F5B8A5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 92,
    rx: 68,
    ry: 60,
    fill: "#EDAA4F",
    stroke: "#4A3426",
    strokeWidth: 3.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 114,
    rx: 11,
    ry: 6.5,
    fill: "#F7A8B8",
    opacity: 0.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 114,
    rx: 27,
    ry: 19,
    fill: "#FBDDA6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 106,
    rx: 9,
    ry: 6.5,
    fill: "#4A3426"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97,
    cy: 104,
    rx: 3,
    ry: 1.8,
    fill: "#fff",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 116 Q95 123 100 117 Q105 123 110 116",
    fill: "none",
    stroke: "#4A3426",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 6.5,
    fill: "#4A3426"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 89.5,
    r: 2.2,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 92,
    r: 6.5,
    fill: "#4A3426"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 89.5,
    r: 2.2,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 15,
    fill: "#fff",
    fillOpacity: 0.25,
    stroke: "#5B3A29",
    strokeWidth: 3.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 92,
    r: 15,
    fill: "#fff",
    fillOpacity: 0.25,
    stroke: "#5B3A29",
    strokeWidth: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87 90 Q100 84 113 90",
    fill: "none",
    stroke: "#5B3A29",
    strokeWidth: 3.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 104,
    width: 62,
    height: 54,
    rx: 11,
    fill: "#FFFDF8",
    stroke: "#4A3426",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 130,
    width: 11,
    height: 19,
    rx: 3,
    fill: "#7FC8A9",
    stroke: "#4A3426",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 145.5,
    y: 118,
    width: 11,
    height: 31,
    rx: 3,
    fill: "#F4B860",
    stroke: "#4A3426",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 124,
    width: 11,
    height: 25,
    rx: 3,
    fill: "#A0CED9",
    stroke: "#4A3426",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKongiDashboard);
export default __webpack_public_path__ + "static/media/kongi-dashboard.097cc16fc472e286a13a4033d6e6cf22.svg";
export { ForwardRef as ReactComponent };